import { WsSelectObj } from 'wisestep-base';

import { getCurrencies } from '../../../utils';

export const createCurrencyObject = (): WsSelectObj[] =>
  getCurrencies().map((e) => ({ label: e, value: e }));
